import store from "@/store"
import { AccountService } from "@/services"

/**
 * Check if role is "admin"
 * @param {*} role
 * @returns
 */
export function isAdmin(role) {
  return role === "administrator"
}

/**
 * Check if role is at least "inspector"
 * @param {*} role
 * @returns
 */
export function isInspector(role) {
  return role === "administrator" || role === "inspector"
}

/**
 * Check if role is "operator"
 * @param {*} role
 * @returns
 */
export function isOperator(role) {
  return role === "operator"
}

/** Logout user */
export const logout = (to, from, next) => {
  AccountService.logout()
  return next({ name: "SignIn" })
}

/** Require User to be authenticated */
export const requireAuth = (to, from, next) => {
  if (store.state.app.user?.key) return next()
  else return next({ name: "SignIn", query: { redirect: to.fullPath } })
}

/** Require User to be administrator */
export const requireAdmin = (to, from, next) => {
  if (store.getters["app/isUserAdmin"]) return next()
  else return next({ name: "Home" })
}

/** Require User to be owner of company */
export const requireCompanyOwner = (to, from, next) => {
  if (store.getters["app/isCompanyOwner"]) return next()
  else return next({ name: "Home" })
}

/** Require User to be inspector on project */
export const requireInspector = (to, from, next) => {
  if (store.getters["app/hasSelectedProject"] && isInspector(store.state.app.project.role)) {
    return next()
  } else return next({ name: "Home" })
}

/** Require User to be staff member A.K. administrator */
export const requireStaff = (to, from, next) => {
  if (store.getters["app/isUserStaff"]) return next()
  else return next({ name: "Home" })
}

/** Require User to be staff member A.K. administrator */
export const requireNoIsPro = (to, from, next) => {
  if (!store.getters["app/isUserPro"]) return next()
  else return next({ name: "TransactionDetail" })
}


/**
 * Verifie une capacite PWA (cle de pwaCapabilities).
 * Si refusee, redirige vers /pwa/history (la seule vue accessible aux pompistes)
 * ou /pwa/home si l'utilisateur a au moins acces a la home.
 */
export const requirePwaCapability = (capabilityKey) => async (to, from, next) => {
  // S'assurer que les privileges sont charges au moins une fois pour les operateurs
  const isPro = store.getters["app/isUserPro"]
  const role = store.state.app.company?.company_role
  const isAdmin = role === "administrator" || role === "manager" || store.state.app.user?.is_company_owner
  if (!isPro && !isAdmin && store.state.app.userPrivileges === null) {
    try {
      await store.dispatch("app/loadUserPrivileges")
    } catch (e) {
      // ignore
    }
  }
  const caps = store.getters["app/pwaCapabilities"]
  if (caps[capabilityKey]) return next()
  // Fallback : pompiste -> historique, autres -> home (qui sera elle-meme filtree)
  if (caps.isPompiste) return next({ name: "PwaHistory" })
  if (caps.canSeeHome) return next({ name: "PwaHome" })
  return next({ name: "PwaProfile" })
}

/**
 * Garde de route web : verifie un privilege business (action_code).
 * Owner / administrator / manager passent toujours.
 * Pour un operateur, charge les privileges si besoin et verifie le code.
 * Sinon, redirige vers Home.
 */
export const requireBusinessPrivilege = (actionCode) => async (to, from, next) => {
  if (!store.state.app.user?.key) return next({ name: "SignIn" })
  // Roles admin -> acces direct
  const company = store.state.app.company
  const role = company && company.company_role
  const isAdmin = store.getters["app/isCompanyOwner"]
    || role === "administrator"
    || role === "manager"
  if (isAdmin) return next()

  // Charger les privileges si pas en cache
  if (store.state.app.userPrivileges === null) {
    try {
      await store.dispatch("app/loadUserPrivileges")
    } catch (e) {
      // ignore
    }
  }
  const codes = store.getters["app/userPrivilegeCodes"]
  if (codes && codes.has && codes.has(actionCode)) return next()
  return next({ name: "Home" })
}

/** Require company to be defined */
export const requireCompany = (to, from, next) => {
  if (store.getters["app/getCompany"] !== -1) return next()
  else return next({ name: "SelectCompany", query: { redirect: to.fullPath } })
}

/** Require project to be defined */
export const requireProject = (to, from, next) => {
  if (store.getters["app/getCompany"] !== -1 && store.getters["app/hasSelectedProject"]) {
    return next()
  } else return next({ name: "Projects" })
}
